module.exports = __webpack_public_path__ + "img/redcross.9b92177e.svg";